module.exports = __webpack_public_path__ + "img/ico-error.f67cd144.svg";